import React from "react";
import { ChartName } from "./analyticsTypes";
import { Layout, Layouts } from "react-grid-layout";
import { STORAGE_KEYS } from "./useActiveCharts";

// Define default layouts
const defaultLayouts: Layouts = {
  lg: [
    {
      w: 6,
      h: 1.4,
      x: 0,
      y: 5.4,
      i: "referralConversions",
      moved: false,
      static: false,
    },
    {
      w: 9,
      h: 1.8,
      x: 0,
      y: 0,
      i: "referralfees",
      moved: false,
      static: false,
    },
    {
      w: 3,
      h: 1.8,
      x: 6,
      y: 3.6,
      i: "growthHistory",
      moved: false,
      static: false,
    },
    {
      w: 3,
      h: 1.8,
      x: 9,
      y: 3.6,
      i: "coinsVisited",
      moved: false,
      static: false,
    },
    {
      w: 3,
      h: 1.8,
      x: 9,
      y: 0,
      i: "referralHoldings",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 1.8,
      x: 0,
      y: 3.6,
      i: "tradinghistory",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 1.4,
      x: 6,
      y: 5.4,
      i: "depositVolume",
      moved: false,
      static: false,
    },
    {
      w: 3,
      h: 1.8,
      x: 0,
      y: 1.8,
      i: "timeToFirstTrade",
      moved: false,
      static: false,
    },
    {
      w: 9,
      h: 1.8,
      x: 3,
      y: 1.8,
      i: "assetsTraded",
      moved: false,
      static: false,
    },
  ],
  md: [
    {
      w: 9,
      h: 1.8,
      x: 0,
      y: 0.8,
      i: "referralfees",
    },
    {
      w: 3,
      h: 1.8,
      x: 9,
      y: 0.8,
      i: "referralHoldings",
    },
    {
      w: 3,
      h: 1.8,
      x: 9,
      y: 2.8,
      i: "coinsVisited",
    },
    {
      w: 6,
      h: 1.8,
      x: 0,
      y: 2.8,
      i: "tradinghistory",
    },
    {
      w: 3,
      h: 1.8,
      x: 6,
      y: 2.8,
      i: "growthHistory",
    },
    {
      w: 6,
      h: 1.4,
      x: 6,
      y: 4.8,
      i: "depositVolume",
    },
    {
      w: 6,
      h: 1.4,
      x: 0,
      y: 4.8,
      i: "referralConversions",
    },
    {
      i: "timeToFirstTrade",
      x: 9,
      y: 6.199999999999999,
      w: 3,
      h: 1.8,
    },
    {
      i: "assetsTraded",
      x: 0,
      y: 7.999999999999999,
      w: 9,
      h: 1.8,
    },
  ],
  sm: [
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: "referralHoldings",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 1.3,
      x: 0,
      y: 4,
      i: "tradinghistory",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 2,
      x: 0,
      y: 0,
      i: "referralfees",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 1.3,
      x: 0,
      y: 5.3,
      i: "growthHistory",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 1.3,
      x: 0,
      y: 6.6,
      i: "referralConversions",
      moved: false,
      static: false,
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: "coinsVisited",
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 2,
      x: 4,
      y: 2,
      i: "depositVolume",
      moved: false,
      static: false,
    },
    {
      i: "timeToFirstTrade",
      x: 0,
      y: 7.8999999999999995,
      w: 4,
      h: 2,
    },
    {
      i: "assetsTraded",
      x: 0,
      y: 9.899999999999999,
      w: 6,
      h: 2,
    },
  ],
  xs: [
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: "referralHoldings",
      moved: false,
      static: false,
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: "referralfees",
      moved: false,
      static: false,
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 6,
      i: "growthHistory",
      moved: false,
      static: false,
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 8,
      i: "referralConversions",
      moved: false,
      static: false,
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 10,
      i: "coinsVisited",
      moved: false,
      static: false,
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 10,
      i: "depositVolume",
      moved: false,
      static: false,
    },
    {
      i: "tradinghistory",
      x: 0,
      y: 12,
      w: 4,
      h: 2,
    },
    {
      i: "timeToFirstTrade",
      x: 0,
      y: 14,
      w: 4,
      h: 2,
    },
    {
      i: "assetsTraded",
      x: 0,
      y: 16,
      w: 6,
      h: 2,
    },
  ],
};

export const useChartLayouts = ({ activeCharts }: { activeCharts: ChartName[] }) => {
  /**
   * Merges saved layout configs with the default layouts for any added charts.
   * i.e. if you want added charts to render at the end of the page instead of their default positioning.
   * Here is where you would change it.
   * For each breakpoint (lg, sm, xs), it:
   * 1. Identifies which active charts don't have layouts
   * 2. Finds their default layouts from defaultLayouts
   * 3. Combines existing layouts with new default layouts
   *
   * @param savedLayouts - Current saved layout configs from localStorage
   * @returns Merged layouts containing both saved positions and default positions for new charts
   */
  const mergeWithDefaultLayouts = React.useCallback(
    (savedLayouts: Layouts): Layouts => {
      const mergedLayouts: Layouts = { lg: [], sm: [], xs: [] };

      Object.keys(savedLayouts).forEach((breakpoint) => {
        const key = breakpoint as keyof Layouts;
        const existingLayouts = savedLayouts[key];
        const existingLayoutIds = existingLayouts.map((layout) => layout.i);

        // Find new charts that need layouts
        const newChartNames = activeCharts.filter(
          (chartName) => !existingLayoutIds.includes(chartName),
        );

        // Find the lowest point in existing layout
        const lowestPoint = existingLayouts.reduce((max, layout) => {
          return Math.max(max, layout.y + layout.h);
        }, 0);

        // Create layouts for new charts using default w/h but positioning at bottom
        const newChartLayouts = newChartNames.map((chartName, index) => {
          // Get default w/h from defaultLayouts
          const defaultLayout = defaultLayouts[key]?.find((layout) => layout.i === chartName);

          return {
            i: chartName,
            x: defaultLayout?.x ?? 0,
            y: lowestPoint + index * (defaultLayout?.h || 4), // Use default height for spacing
            w: defaultLayout?.w || 4, // Use default width or fallback
            h: defaultLayout?.h || 2, // Use default height or fallback
          };
        });

        mergedLayouts[key] = [...existingLayouts, ...newChartLayouts];
      });

      return mergedLayouts;
    },
    [activeCharts],
  );

  /**
   * Retrieves and processes layout configs for all charts.
   * This function:
   * 1. Attempts to load saved layouts from localStorage
   * 2. If no saved layouts exist, filters default layouts based on active charts
   * 3. If saved layouts exist, merges them with default layouts for new charts
   * 4. Ensures only active charts are included in the final layout
   *
   * @returns Final layout config for all active charts
   */
  const getSavedLayouts = React.useCallback(() => {
    try {
      const savedLayouts = localStorage.getItem(STORAGE_KEYS.LAYOUTS);

      if (!savedLayouts) {
        // If no saved layouts, filter the default layouts based on active charts
        return Object.keys(defaultLayouts).reduce((acc, breakpoint) => {
          const key = breakpoint as keyof Layouts;
          acc[key] = defaultLayouts[key].filter((item) =>
            activeCharts.includes(item.i as ChartName),
          );
          return acc;
        }, {} as Layouts);
      }

      // Get saved layouts and merge with defaults for new charts
      const parsedLayouts = JSON.parse(savedLayouts) as Layouts;
      const mergedLayouts = mergeWithDefaultLayouts(parsedLayouts);

      // Filter to only include active charts
      return Object.keys(mergedLayouts).reduce((acc, breakpoint) => {
        const key = breakpoint as keyof Layouts;
        acc[key] = mergedLayouts[key].filter((item) => activeCharts.includes(item.i as ChartName));
        return acc;
      }, {} as Layouts);
    } catch (error) {
      console.error("Error loading saved layouts:", error);
      return defaultLayouts;
    }
  }, [activeCharts, mergeWithDefaultLayouts]);

  /**
   * Callback function triggered when the grid layout changes.
   *
   * The function is called by react-grid-layout whenever:
   * - Charts are moved
   * - Charts are resized
   * - Breakpoints change
   * - Charts are added or removed
   *
   * @param currentLayout - Current layout for the active breakpoint
   * @param allLayouts - All layouts for all breakpoints
   */
  const onLayoutChange = React.useCallback(
    (currentLayout: Layout[], allLayouts: Layouts) => {
      // Only save layouts for active charts
      const filteredLayouts = Object.keys(allLayouts).reduce((acc, breakpoint) => {
        const key = breakpoint as keyof Layouts;
        acc[key] = allLayouts[key].filter((item) => activeCharts.includes(item.i as ChartName));
        return acc;
      }, {} as Layouts);

      localStorage.setItem(STORAGE_KEYS.LAYOUTS, JSON.stringify(filteredLayouts));
    },
    [activeCharts],
  );

  return { getSavedLayouts, onLayoutChange };
};
